module.exports = __webpack_public_path__ + "static/fonts/Spoqa-Han-Sans-Thin.366a745.woff2";